import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['arithmetic'] = function (block: Blockly.Block): [string, number] {
        const a = gen.valueToCode(block, 'A', 0) || '0';
        const b = gen.valueToCode(block, 'B', 0) || '0';
        const op = block.getFieldValue('OP');

        if (op === 'MOD') {
            return expr(`fmod(${a}, ${b})`);
        }

        const opMap: Record<string, string> = {
            ADD: '+',
            SUB: '-',
            MUL: '*',
            DIV: '/',
        };

        return expr(`(${a} ${opMap[op]} ${b})`);
    };
}
